import InviteListItemSkeleton from "./invite-list-item-skeleton";

export interface InviteListSkeletonProps {
	count?: number;
	className?: string;
}

export default function InviteListSkeleton({ count = 3, className = "" }: InviteListSkeletonProps) {
	return (
		<div className={`divide-y divide-gray-200 ${className}`}>
			{Array.from({ length: count }).map((_, index) => (
				<InviteListItemSkeleton key={index} />
			))}
		</div>
	);
}
